var render = function render(){
  var _vm$$store$state$conf, _vm$$store$state$conf2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('span', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : _vm.hasError ? _c('div', {
    staticClass: "container mt-4"
  }, [_c('div', {
    staticClass: "alert alert-danger text-center"
  }, [_c('font-awesome-icon', {
    staticClass: "text-danger",
    attrs: {
      "icon": "circle-xmark"
    }
  }), _vm._v(" Door een interne fout is OMS op dit moment niet beschikbaar. Probeer het a.u.b. over enkele minuten nogmaals. ")], 1)]) : !_vm.isLoggedIn ? _c('div', {
    staticClass: "container mt-4"
  }, [_c('div', {
    staticClass: "alert alert-danger text-center"
  }, [_vm._v(" Je bent niet ingelogd. "), ((_vm$$store$state$conf = _vm.$store.state.config) === null || _vm$$store$state$conf === void 0 ? void 0 : (_vm$$store$state$conf2 = _vm$$store$state$conf.general) === null || _vm$$store$state$conf2 === void 0 ? void 0 : _vm$$store$state$conf2.environment) !== 'local' ? _c('span', [_vm._v(" Je wordt binnen enkele seconden doorverwezen... "), _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _vm._e()])]) : _c('div', {
    staticClass: "app-container app-theme-white body-tabs-shadow fixed-sidebar fixed-header"
  }, [_c('header-vue'), _c('div', {
    staticClass: "app-main"
  }, [_c('div', {
    staticClass: "app-sidebar sidebar-shadow sidebar-text-light"
  }, [_c('div', {
    staticClass: "scrollbar-sidebar ps",
    staticStyle: {
      "overflow-y": "auto !important"
    }
  }, [_c('div', {
    staticClass: "app-sidebar__inner"
  }, [_c('menu-vue')], 1)])]), _c('div', {
    staticClass: "app-main__outer"
  }, [_c('div', {
    staticClass: "app-main__inner"
  }, [_c('router-view', {
    key: _vm.$root.routerKey
  }), _c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": !_vm.$root.routerKey
    }
  }, [_vm._v(" Pagina niet gevonden ")])], 1)])]), _c('alert-container')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }